export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    // Deriva badge a partir do href atual (preserva ?v=... automaticamente)
    const currentHref = favicon.getAttribute('href') || '';
    const newFileName = currentHref.replace('/favicon-', '/favicon-badge-');
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');
  // Salva hrefs originais do HTML (inclui ?v=bmt6 ou qualquer versao)
  const originalHrefs = Array.from(favicons).map(f => f.getAttribute('href'));

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach((favicon, i) => {
        favicon.href = originalHrefs[i];
      });
    }
  });
};
